import script from "./PlanSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanSingle.vue?vue&type=script&setup=true&lang=js"

import "./PlanSingle.vue?vue&type=style&index=0&id=27640c80&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27640c80"]])

export default __exports__